import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 bg-gray-50 py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow p-8 sm:p-12">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
            <p className="text-gray-600 mb-1"><strong>Effective Date:</strong> 03/14/2026</p>
            <p className="text-gray-600 mb-8"><strong>Company:</strong> Matter King, Inc.</p>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Introduction</h2>
              <p className="text-gray-700 leading-relaxed">MatterKing ("Company," "we," "our," or "us") respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, disclose, and safeguard information when you visit our website and use our software-as-a-service platform (the "Services").</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Information We Collect</h2>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Information You Provide</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-4">
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Company name</li>
                <li>Account credentials</li>
                <li>Billing information</li>
                <li>Uploaded documents or content</li>
              </ul>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Automatically Collected Information</h3>
              <ul className="list-disc list-inside text-gray-700 space-y-1">
                <li>IP address</li>
                <li>Browser and device information</li>
                <li>Operating system</li>
                <li>Usage data</li>
                <li>Cookies and tracking data</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">3. How We Use Information</h2>
              <ul className="list-disc list-inside text-gray-700 space-y-1 mb-3">
                <li>Provide and operate our Services</li>
                <li>Authenticate users</li>
                <li>Process transactions</li>
                <li>Improve our platform</li>
                <li>Ensure security and prevent fraud</li>
                <li>Comply with legal obligations</li>
              </ul>
              <p className="text-gray-700 font-medium">We do not sell personal information.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Sharing of Information</h2>
              <p className="text-gray-700 leading-relaxed">We may share information with trusted service providers, legal authorities when required, or in connection with a business transaction such as a merger or acquisition.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Data Retention</h2>
              <p className="text-gray-700 leading-relaxed">We retain personal information as long as necessary to provide Services, comply with legal obligations, and enforce agreements. When no longer needed, data is securely deleted or anonymized.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Data Security</h2>
              <p className="text-gray-700 leading-relaxed">We implement reasonable administrative, technical, and physical safeguards including encryption in transit, access controls, and system monitoring.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Your Rights</h2>
              <p className="text-gray-700 leading-relaxed">Depending on your location, you may have rights to access, correct, delete, or restrict processing of your personal data. Contact us at privacy@matterking.com to exercise your rights.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">8. California Privacy Rights</h2>
              <p className="text-gray-700 leading-relaxed">California residents may request disclosure, correction, or deletion of personal information under applicable law. We do not sell personal information.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Children's Privacy</h2>
              <p className="text-gray-700 leading-relaxed">Our Services are not directed to children under 13. We do not knowingly collect personal information from children.</p>
            </section>

            <section className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-3">10. Changes to This Policy</h2>
              <p className="text-gray-700 leading-relaxed">We may update this Privacy Policy periodically. Updates will be posted with a revised effective date.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
